<template>
  <div>
    <v-card flat class="mt-7">
      <v-card-text>
        <GroupInfoDetail />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import GroupInfoDetail from "./group-info/GroupInfoDetail.vue";


export default {
  components: {
    GroupInfoDetail
  },
};
</script>
<style lang="scss" scoped>
.bdr {
  border: thin solid $secondary-color;
}
</style>